// Cadenas del calendario. El idioma lo fija la pagina (Polylang -> <html lang>); aqui no hay logica de idioma propia.
// EN: la leyenda oficial de la pagina dice "MIXED FREIGHT ROUTE. (BLACK FREIGHT VEHICLES AND FAMILY VEHICLES MAY TRAVEL)"
// y "Subject to change without prior notice" (Elementor, /en/schedules/). Se reutilizan; marcadas REVISION EDITORIAL.
export const STRINGS = {
  es: {
    locale: 'es-MX',
    title: 'HORARIOS',
    departingFrom: 'Saliendo de',
    origin: { cozumel: 'Cozumel', calica: 'Calica' },
    mixed: 'Carga mixta',
    mixedRoute: 'Ruta de carga mixta',
    mixedExplain: 'Podrán viajar vehículos de carga negra y vehículos familiares.',
    notice: 'Sujeto a cambios sin previo aviso.',
    prev: 'Semana anterior',
    next: 'Semana siguiente',
    week: 'Semana',
    today: 'Hoy',
    days: 'Días de la semana',
    loading: 'Cargando horarios…',
    empty: 'Sin horarios disponibles',
    emptyWeek: 'No hay salidas programadas para esta semana.',
    error: 'No fue posible cargar los horarios',
    errorHint: 'Revisa tu conexión e inténtalo de nuevo.',
    retry: 'Reintentar',
    tableCaption: 'Horarios de salida de la semana',
    noDeparture: 'Sin salidas',
  },
  en: {
    locale: 'en-US',
    title: 'SCHEDULES',
    departingFrom: 'Departing from',
    origin: { cozumel: 'Cozumel', calica: 'Calica' },
    mixed: 'Mixed freight',
    mixedRoute: 'Mixed freight route',
    mixedExplain: 'Black freight vehicles and family vehicles may travel.',
    notice: 'Subject to change without prior notice.',
    prev: 'Previous week',
    next: 'Next week',
    week: 'Week',
    today: 'Today',
    days: 'Days of the week',
    loading: 'Loading schedules…',
    empty: 'No schedules available',
    emptyWeek: 'There are no departures scheduled for this week.',
    error: 'Schedules could not be loaded',
    errorHint: 'Check your connection and try again.',
    retry: 'Retry',
    tableCaption: 'Departure schedule for the week',
    noDeparture: 'No departures',
  },
};

export function detectLang(doc = document) {
  const l = ((doc.documentElement && doc.documentElement.lang) || '').toLowerCase();
  return l.startsWith('en') ? 'en' : 'es';
}
